document.addEventListener('DOMContentLoaded', () => {
  console.log('Calculator script initialized!'); // Debug logging

  const steps = document.querySelectorAll('.calculator-step');
  const stepIndicators = document.querySelectorAll('.step-indicator .step');
  const profileForm = document.getElementById('profile-form');
  const continueButton = document.getElementById('btn-step1-continue');
  const backButtons = document.querySelectorAll('.btn-back');
  const calculateButton = document.getElementById('btn-step2-calculate');
  const goalOptions = document.querySelectorAll('.goal-option input[name="goal"]');
  const recommendationsButton = document.getElementById('btn-step3-recommendations');
  const resultsGoalDisplay = document.getElementById('results-goal-display');
  const resultsCalories = document.getElementById('results-calories');
  const resultsProteinGrams = document.getElementById('results-protein-grams');
  const resultsProteinPercent = document.getElementById('results-protein-percent');
  const resultsProteinBar = document.getElementById('results-protein-bar');
  const resultsCarbsGrams = document.getElementById('results-carbs-grams');
  const resultsCarbsPercent = document.getElementById('results-carbs-percent');
  const resultsCarbsBar = document.getElementById('results-carbs-bar');
  const resultsFatGrams = document.getElementById('results-fat-grams');
  const resultsFatPercent = document.getElementById('results-fat-percent');
  const resultsFatBar = document.getElementById('results-fat-bar');

  // Meal recommendation elements
  const tabLinks = document.querySelectorAll('.tab-link');
  const tabContents = document.querySelectorAll('.tab-content');
  const saveButton = document.getElementById('btn-step4-save');
  const emailForm = document.getElementById('email-form');
  const sendEmailButton = document.getElementById('btn-step5-send');

  let currentStep = 1;
  const calculatorData = {
    profile: {},
    goal: 'maintenance',
    results: {},
  };

  // Debug logging for elements
  console.log('Continue button found:', !!continueButton);
  console.log('Profile form found:', !!profileForm);

  function updateStepIndicator(targetStep) {
    stepIndicators.forEach((indicator) => {
      const step = parseInt(indicator.dataset.step, 10);
      if (step <= targetStep) {
        indicator.classList.add('active');
      } else {
        indicator.classList.remove('active');
      }
    });
  }

  function navigateToStep(targetStep) {
    console.log(`Navigating to step ${targetStep}`); // Debug logging

    // Ensure targetStep is within bounds
    targetStep = Math.max(1, Math.min(targetStep, steps.length));

    // Remove active class from all steps
    steps.forEach((step) => {
      step.classList.remove('active');
    });

    // Update progress bar
    const stepIndicator = document.querySelector('.step-indicator');
    if (stepIndicator) {
      stepIndicator.setAttribute('data-current-step', targetStep);
    }

    // Update step indicators
    stepIndicators.forEach((indicator) => {
      const step = parseInt(indicator.dataset.step, 10);

      // Mark previous steps as completed
      if (step < targetStep) {
        indicator.classList.add('completed');
        indicator.classList.remove('active');
      }
      // Mark current step as active
      else if (step === targetStep) {
        indicator.classList.add('active');
        indicator.classList.remove('completed');

        // Add animation class briefly
        indicator.classList.add('just-completed');
        setTimeout(() => {
          indicator.classList.remove('just-completed');
        }, 500);
      }
      // Reset future steps
      else {
        indicator.classList.remove('active', 'completed');
      }
    });

    const targetStepElement = document.getElementById(`step-${targetStep}`);
    if (targetStepElement) {
      targetStepElement.classList.add('active');
      currentStep = targetStep;

      // Update results display if navigating to step 3
      if (targetStep === 3) {
        updateResultsDisplay();
      }

      // Remove auto-scrolling behavior
      /*
      const container = document.querySelector('.calculator-container');
      if (container) {
        container.scrollIntoView({ behavior: 'smooth' });
      }
      */
    } else {
      console.error(`Step element with ID step-${targetStep} not found.`);
    }
  }

  // Prevent form submission on the entire profile form
  if (profileForm) {
    profileForm.addEventListener('submit', (event) => {
      console.log('Form submission prevented'); // Debug logging
      event.preventDefault();
      return false;
    });
  }

  // Step 1: Handle continue button click
  if (continueButton) {
    console.log('Adding click event to continue button');

    continueButton.addEventListener('click', (event) => {
      console.log('Continue button clicked!'); // Debug logging
      event.preventDefault();

      if (!profileForm.checkValidity()) {
        profileForm.reportValidity();
        return;
      }

      // Store form data
      const formData = new FormData(profileForm);
      formData.forEach((value, key) => {
        calculatorData.profile[key] = value;
      });

      console.log('Profile data collected:', calculatorData.profile);
      navigateToStep(2);
    });
  } else {
    console.error('Continue button not found!');
  }

  // Step 2: Calculate button
  if (calculateButton) {
    calculateButton.addEventListener('click', () => {
      // Find the selected goal
      const selectedGoal = document.querySelector('.goal-option input[name="goal"]:checked');
      if (selectedGoal) {
        calculatorData.goal = selectedGoal.value;
      } else {
        console.warn('No goal selected, defaulting to maintenance.');
        calculatorData.goal = 'maintenance';
      }

      // Perform calculations
      const bmr = calculateBMR(calculatorData.profile);
      const tdee = calculateTDEE(bmr, calculatorData.profile.activity_level);
      const targetCalories = adjustTDEEForGoal(tdee, calculatorData.goal);
      const macros = calculateMacros(targetCalories);

      // Store results
      calculatorData.results = {
        bmr,
        tdee,
        targetCalories,
        macros,
        macroPercentages: { protein: 30, carbs: 40, fat: 30 },
      };

      navigateToStep(3);
    });
  }

  // Step 3: View Recommendations Button
  if (recommendationsButton) {
    recommendationsButton.addEventListener('click', () => {
      navigateToStep(4);
    });
  }

  // Step 4: Tab Navigation
  tabLinks.forEach((link) => {
    link.addEventListener('click', () => {
      const targetTabId = link.dataset.tab;

      // Update tab links UI
      tabLinks.forEach((tl) => tl.classList.remove('active'));
      link.classList.add('active');

      // Update tab content visibility
      tabContents.forEach((content) => {
        if (content.id === `tab-${targetTabId}`) {
          content.classList.add('active');
        } else {
          content.classList.remove('active');
        }
      });
    });
  });

  // Step 4: Save Results Button
  if (saveButton) {
    saveButton.addEventListener('click', () => {
      navigateToStep(5);
    });
  }

  // Back buttons
  backButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const targetStepId = button.dataset.target;
      const targetStepNumber = parseInt(targetStepId.replace('step-', ''), 10);
      if (!isNaN(targetStepNumber)) {
        navigateToStep(targetStepNumber);
      }
    });
  });

  // Calculation Functions
  function calculateBMR(profile) {
    const age = parseFloat(profile.age);
    const weight = parseFloat(profile.weight);
    const height = parseFloat(profile.height);
    const gender = profile.gender;

    if (isNaN(age) || isNaN(weight) || isNaN(height) || !gender) {
      console.error('Invalid profile data for BMR calculation');
      return 0;
    }

    let bmr;
    if (gender === 'male') {
      bmr = 10 * weight + 6.25 * height - 5 * age + 5;
    } else {
      bmr = 10 * weight + 6.25 * height - 5 * age - 161;
    }
    return Math.round(bmr);
  }

  function calculateTDEE(bmr, activityFactor) {
    const factor = parseFloat(activityFactor);
    if (isNaN(bmr) || isNaN(factor) || bmr <= 0 || factor <= 0) {
      console.error('Invalid input for TDEE calculation');
      return 0;
    }
    return Math.round(bmr * factor);
  }

  function adjustTDEEForGoal(tdee, goal) {
    if (isNaN(tdee) || tdee <= 0) return 0;

    let adjustment = 0;
    switch (goal) {
      case 'loss':
        adjustment = -500;
        break;
      case 'gain':
        adjustment = 300;
        break;
      case 'maintenance':
      default:
        adjustment = 0;
        break;
    }
    return Math.max(1200, Math.round(tdee + adjustment));
  }

  function calculateMacros(calories) {
    if (isNaN(calories) || calories <= 0) return { protein: 0, carbs: 0, fat: 0 };

    const proteinPercent = 0.3;
    const carbPercent = 0.4;
    const fatPercent = 0.3;

    const proteinGrams = Math.round((calories * proteinPercent) / 4);
    const carbGrams = Math.round((calories * carbPercent) / 4);
    const fatGrams = Math.round((calories * fatPercent) / 9);

    return {
      protein: proteinGrams,
      carbs: carbGrams,
      fat: fatGrams,
    };
  }

  function updateResultsDisplay() {
    if (!calculatorData.results || Object.keys(calculatorData.results).length === 0) {
      console.error('Results data is missing, cannot update display.');
      return;
    }

    const { targetCalories, macros, macroPercentages } = calculatorData.results;
    const goalText = calculatorData.goal || 'maintenance';

    // Update goal display text
    if (resultsGoalDisplay) resultsGoalDisplay.textContent = goalText;

    // Update calories
    if (resultsCalories) resultsCalories.textContent = `${targetCalories.toLocaleString()} kcal`;

    // Update Macros
    if (resultsProteinGrams) resultsProteinGrams.textContent = macros.protein;
    if (resultsProteinPercent) resultsProteinPercent.textContent = macroPercentages.protein;
    if (resultsProteinBar) resultsProteinBar.style.width = `${macroPercentages.protein}%`;

    if (resultsCarbsGrams) resultsCarbsGrams.textContent = macros.carbs;
    if (resultsCarbsPercent) resultsCarbsPercent.textContent = macroPercentages.carbs;
    if (resultsCarbsBar) resultsCarbsBar.style.width = `${macroPercentages.carbs}%`;

    if (resultsFatGrams) resultsFatGrams.textContent = macros.fat;
    if (resultsFatPercent) resultsFatPercent.textContent = macroPercentages.fat;
    if (resultsFatBar) resultsFatBar.style.width = `${macroPercentages.fat}%`;
  }

  // Email form submission
  if (emailForm) {
    emailForm.addEventListener('submit', (event) => {
      event.preventDefault();

      if (!emailForm.checkValidity()) {
        emailForm.reportValidity();
        return;
      }

      const email = emailForm.querySelector('#email').value;
      calculatorData.email = email;

      // In a real app, you would send data to a backend here
      const step5Content = document.getElementById('step-5');
      if (step5Content) {
        step5Content.innerHTML = `
          <h2>¡Resultados Enviados!</h2>
          <p>Hemos enviado tu plan nutricional personalizado a <strong>${email}</strong>.</p>
          <p>Revisa tu bandeja de entrada (y la carpeta de spam).</p>
          <div class="calculator-nav">
             <button type="button" class="btn btn-secondary btn-back" data-target="step-4">&lt; Atrás</button>
          </div>
        `;

        // Re-attach back button listener
        const newBackButton = step5Content.querySelector('.btn-back');
        if (newBackButton) {
          newBackButton.addEventListener('click', () => {
            navigateToStep(4);
          });
        }
      }
    });
  }

  // Initialize
  updateStepIndicator(currentStep);

  // Add inline click handler to the first button (as a backup)
  if (continueButton) {
    continueButton.onclick = function (e) {
      console.log('Inline click handler triggered');
      e.preventDefault();

      if (profileForm && profileForm.checkValidity()) {
        // Store form data
        const formData = new FormData(profileForm);
        formData.forEach((value, key) => {
          calculatorData.profile[key] = value;
        });
        navigateToStep(2);
      } else if (profileForm) {
        profileForm.reportValidity();
      }

      return false;
    };
  }
});
